<template>
  <v-container fluid>
    <v-card style="margin-top: 20px">
      <v-card flat>
        <v-layout row style="margin-bottom: 16px;">
          <v-card flat>
            <v-card-text class="title">July Fighters List</v-card-text>
          </v-card>
          <v-divider class="my-2" vertical></v-divider>
          <v-text-field
            v-model="search"
            prepend-inner-icon="search"
            label="Search by Reg No"
            class="mt-0"
            hide-details
            solo
            flat
            type="number"
            single-line
          ></v-text-field>
          <v-spacer />
          <v-flex
            class="customeDateSearch text-xs-right"
            xs2
            style="margin-top: 5px; margin-bottom: 3px;"
          >
            <v-layout row justify-end>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: tooltipOn }">
                      <v-btn
                        dark
                        color="primary"
                        v-on="{ ...on, ...tooltipOn }"
                      >
                        <v-icon dark>add</v-icon> Add New
                      </v-btn>
                    </template>
                    <span>Add New Reg No to July Fighters</span>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-card-title style="background-color: #3f51b5; color: #fff">
                    <span class="headline">Input Registration Numbers</span>
                    <v-spacer></v-spacer>
                    <v-btn color="red" fab small dark @click="dialog = false"
                      ><v-icon>close</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          class="custom-multiline-text-field"
                          v-model="reg_numbers"
                          label="Enter Registration Numbers"
                          @input="formatInput"
                          :error-messages="errorMessage"
                          textarea
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <small style="color: red; font-size: 13px"
                      >Enter Registration Numbers With
                      <strong>Comma (,)</strong> separated</small
                    >
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="showBot == 1 && reg_numbers != ''"
                      color="blue darken-1"
                      flat
                      @click="
                        $event.preventDefault();
                        $event.stopPropagation();
                        saveJulyFighters();
                      "
                      >submits</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-flex>
        </v-layout>

        <h1 style="margin-bottom: -15px; margin-left: 48px; font-size: 19px; color: #fff;"></h1>
        <v-data-table
          :headers="headers"
          :items="filteredFighters"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[50, 100, 150, { text: 'All', value: -1 }]"
          :loading="loading"
          item-key="reg_no"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">{{ props.item.rn }}</td>

              <td>{{ props.item.reg_no }}</td>

              <td>{{ props.item.name }}</td>

              <td>
                {{ props.item.college_code }} - {{ props.item.college_name }}
              </td>

              <td>{{ props.item.added_by }}</td>

              <td class="text-xs-center">
                <v-btn
                  color="red"
                  fab
                  small
                  dark
                  @click="deleteFighter(props.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-container>
</template>
<script>
import commonGet from "@/mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
export default {
  mixins: [commonGet, commonExamYear],
  data() {
    return {
      search: "",
      searchParam: {
        status: 1,
        exam_initiate_id: null,
        exam_year: null,
        id: null,
        delete_existing_data: 0,
      },
      headers: [
        {
          text: "SL",
          align: "center",
          value: "rn",
          sortable: false,
        },
        { text: "Reg No", value: "reg_no", sortable: false },
        { text: "Name", value: "name", sortable: false },
        { text: "College Code & Name", value: "college_name", sortable: false },
        { text: "Added By", value: "added_by", sortable: false },
        { text: "Action", value: "", sortable: false },
      ],
      totalItems: 0,
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 50,
      },
      dialog: false,
      reg_numbers: "",
      errorMessage: "",
      showBot: 1,
    };
  },
  created() {
    this.searchParam.exam_initiate_id = this.getExamInitiateId;
    this.searchParam.exam_year = this.getLoggedInYear.year;
    this.fetchJulyFighterList();
  },
  computed: {
    getJulyFighterData() {
      return this.$store.getters.getJulyFighterList;
    },
    filteredFighters() {
      const list =
        (this.getJulyFighterData &&
          this.getJulyFighterData.data &&
          this.getJulyFighterData.data.data) ||
        [];
      if (!this.search) {
        return list;
      }
      return list.filter((item) => String(item.reg_no).includes(this.search));
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchJulyFighterList();
      },
      deep: true,
    },
  },
  methods: {
    fetchJulyFighterList() {
      let peram = {
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
        display_type: "show_data",
      };
      console.log("Tanvir, this is Load Data param", peram);
      this.loading = true;
      this.$store.dispatch("fetchJulyFighterData", peram).then((res) => {
        console.log("Tanvir, this is Load Data Response", res);
        this.loading = false;
        this.totalItems = res.data.total;
        this.pagination.rowsPerPage = res.data.per_page;
      });
    },
    // Reg No is 11 digits long, so a comma is inserted after every 11 digits
    // instead of every 4 digits (unlike the college_code bulk-entry logic).
    formatInput() {
      if (/[A-Za-z]/.test(this.reg_numbers)) {
        this.errorMessage = "Only numbers are accepted";
        this.showBot = 0;
        return;
      } else {
        this.errorMessage = "";
        this.showBot = 1;
      }
      const plainNumber = this.reg_numbers.replace(/,/g, "");
      const formattedValue = plainNumber.replace(/(.{11})(?!$)/g, "$1,");
      this.reg_numbers = formattedValue;
      this.number = plainNumber;
    },
    saveJulyFighters() {
      this.dialog = true;
      let fighterParam = {
        exam_code: this.searchParam.exam_code,
        exam_year: this.searchParam.exam_year,
        reg_nos: this.reg_numbers,
      };
      console.log("Tanvir, this is new July Fighters data", fighterParam);
      this.$store.dispatch("postJulyFighterData", fighterParam).then(() => {
        this.loading = false;
        this.dialog = false;
        this.reg_numbers = "";
        this.fetchJulyFighterList();
      });
    },

    deleteFighter(id) {
      console.log("Tanvir! This is delete ID:", id);

      if (!confirm("Are you sure you want to delete this July Fighter?")) {
        return;
      }
      this.$store
        .dispatch("deleteJulyFighterData", id)
        .then((message) => {
          console.log("Delete success:", message);
          this.fetchJulyFighterList();
          this.search = "";
        })
        .catch((error) => {
          console.error("Delete failed:", error);
        });
    },
  },
};
</script>
<style></style>